'use client';
import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const API_KEY = process.env.GOOGLE_MAP_API_KEY || 'AIzaSyDVmiXgRg9TlnqpJbcvAcZ0A0UsqJwMSws';

const GoogleMapComponent = ({ lat, lng }: { lat: number, lng: number }) => {
  return (
    <LoadScript googleMapsApiKey={API_KEY}>
      <GoogleMap
        mapContainerStyle={{ height: '100%', width: '100%', borderRadius: '16px' }}
        center={{
          lat: lat,
          lng: lng,
        }}
        zoom={15}
      >
        <Marker position={{
          lat: lat,
          lng: lng,
        }}
        />
      </GoogleMap>
    </LoadScript>
  );
};

export default GoogleMapComponent;
